import { createAsyncThunk, createSlice } from "@reduxjs/toolkit"
import AuthAxios from "../../config/authAxios"
import apiRoutes from "../apiConfigs";

export const contentConsumptionGraphApi = createAsyncThunk(
    'auth/contentConsumptionGraph/graph',
    async (requestData, { rejectWithValue }) => {
        try {
            const { params } = requestData;
            const response = await AuthAxios.get(apiRoutes.contentConsumptionGraph(), { params })
            return response?.data
        } catch (error) {
            return rejectWithValue(error?.response?.data)
        }
    }
)
const intialStateContentGraph = { result: [], loading: false, error: null, message: "" }
const contentConsumptionGraphSlice = createSlice({
    name: 'contentConsumptionGraph/graph',
    initialState: intialStateContentGraph,
    reducers: {
        resetContentConsumptionGraph: () => intialStateContentGraph,
    },
    extraReducers: (builder) => {
        builder.addCase(contentConsumptionGraphApi.pending, (state, action) => {
            state.loading = true
        })
        builder.addCase(contentConsumptionGraphApi.fulfilled, (state, action) => {
            state.loading = false
            state.result = action?.payload
            state.message = action?.payload?.message
        })
        builder.addCase(contentConsumptionGraphApi.rejected, (state, action) => {
            state.loading = false
            state.error = action?.payload?.error
            state.message = action?.payload?.message
        })
    },
})
export const { resetContentConsumptionGraph } = contentConsumptionGraphSlice.actions;
export const contentConsumptionGraphReducer = contentConsumptionGraphSlice.reducer